/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'host-hdr-match-with-objects';
const prefix = `${moduleName}.${componentName}`;

export const enterCriteriaLabel = `${prefix}.enterCriteriaLabel`;
export const enterValuesLabel = `${prefix}.enterValuesLabel`;
export const addValueLabel = `${prefix}.addValueLabel`;

export const ENGLISH = {
    [enterCriteriaLabel]: 'Enter Criteria',
    [addValueLabel]: 'Add Value',
    [enterValuesLabel]: 'Enter Values',
};
